import {
  PaginatedRequisitionsResponse,
  Requisition,
  RequisitionNotificationSettings,
  SaveRequisitionNotificationSettingsPayload,
} from '@customTypes/requisition';
import axios from '@hooks/useAxios';

export * from './draftOrderActions';

const requisitionBaseUrl = '/requisition';
const providerPortalRequisitionBaseUrl = '/provider/requisition';

export interface RequisitionMetrics {
  total: number;
  reported: number;
  outstanding: number;
}

export const fetchPaginatedRequisitions = async (params: URLSearchParams): Promise<PaginatedRequisitionsResponse> =>
  axios.get<PaginatedRequisitionsResponse>(providerPortalRequisitionBaseUrl, { params }).then(res => res.data);

export const fetchRequisitionMetrics = async (): Promise<RequisitionMetrics> =>
  axios.get<RequisitionMetrics>(`${providerPortalRequisitionBaseUrl}/metrics`).then(res => res.data);

export const fetchRequisitionById = async (requisitionId: string): Promise<Requisition> => {
  return axios.get(`${requisitionBaseUrl}/${requisitionId}`).then(res => res.data);
};

// TODO: replace the unknown with an actual type.
export const placeOrder = async (payload: unknown) => {
  return axios.post(requisitionBaseUrl, payload);
};

export const getRequisitionNotificationSettings = async (
  requisitionId: string,
): Promise<RequisitionNotificationSettings> => {
  return axios
    .get<RequisitionNotificationSettings>(
      `${providerPortalRequisitionBaseUrl}/${requisitionId}/notification-settings`,
      { skipResponseInterceptor: true },
    )
    .then(res => res.data);
};

export const saveRequisitionNotificationSettings = async (
  requisitionId: string,
  payload: SaveRequisitionNotificationSettingsPayload,
): Promise<RequisitionNotificationSettings> => {
  return axios
    .post<RequisitionNotificationSettings>(
      `${providerPortalRequisitionBaseUrl}/${requisitionId}/notification-settings`,
      payload,
      { skipResponseInterceptor: true },
    )
    .then(res => res.data);
};
